import React from 'react';
import PropTypes from 'prop-types';
import { FaTrash as DeleteIcon } from 'react-icons/fa';

import Spinner from '../../shared/spinner.component';
import ContentButton from './contentButton.component';
import AddContentButton from './addContentButton.component';

const getRightIcon = (currentContentDeleting, deleteContent) => {
  if (!deleteContent) {
    return null;
  }
  if (currentContentDeleting) {
    return <Spinner className="ContentButton-deletingIcon" small/>;
  }

  return <DeleteIcon className="ContentButton-deleteIcon" onClick={deleteContent} />;
};

const ContentButtonList = ({
  helpContents,
  sectionName,
  deleteContent,
  deleteContentLoading,
  addContent,
  addContentLoading,
  loading,
  additionalContent,
}) => (
  <>
    {sectionName
      ? (
        <ContentButton header to={`/section/${sectionName}`}>
          {sectionName}
        </ContentButton>
      )
      : null
    }
    {!loading && helpContents.map(helpItem => (
      <ContentButton
        key={helpItem.contentId}
        to={`/content/${helpItem.contentId}`}
        rightIcon={getRightIcon(
          deleteContentLoading === helpItem.contentId,
          deleteContent && deleteContent(helpItem.contentId)
        )}
      >
        {helpItem.title}
      </ContentButton>
    ))}
    {loading ? <Spinner/> : null}
    {additionalContent}
    {addContent ? (<AddContentButton onSubmit={addContent} loading={addContentLoading}/>) : null}
  </>
);

ContentButtonList.propTypes = {
  helpContents: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    contentId: PropTypes.number,
  })).isRequired,
  sectionName: PropTypes.string,
  deleteContent: PropTypes.func,
  deleteContentLoading: PropTypes.bool,
  addContent: PropTypes.func,
  addContentLoading: PropTypes.bool,
  loading: PropTypes.bool,
  additionalContent: PropTypes.node,
};

export default ContentButtonList;
